import { MarketType } from "../type/MarketType";
import { LocationGroupSubGroupModel, LocationGroupModel, FixtureGroupWithFixturesModel } from "../../imagine-ui-ng-store-profile";
import { MarketGroupModel } from "./MarketGroupModel";
import { LocationAttributeSearchModel } from "./LocationAttributeSearchModel";

export class MarketSearchModalReturnModel {
    constructor(public ResultType: MarketType,
        public Result: LocationGroupSubGroupModel | LocationGroupSubGroupModel[] | LocationAttributeSearchModel | LocationAttributeSearchModel[] | LocationGroupModel | LocationGroupModel[] | MarketGroupModel | MarketGroupModel[] | FixtureGroupWithFixturesModel | FixtureGroupWithFixturesModel[]) { }
}
